import type { QueryKey } from '@tanstack/react-query';
import { http } from 'services/http';
import { CARGO_GET_ONE, DOCUMENTS_GET_MANY } from 'api/query-keys.ts';
import type { DocumentRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useDeleteDocument = () => {
  return useMutationBase<DocumentRes, unknown, { documentId: number }>({
    mutationFn: async (variables) => {
      const res = await http.delete<DocumentRes>(`/v1/documents/${variables.documentId}`);

      return res.data;
    },

    invalidateCallback: ({ cargoId }) => {
      const keys: QueryKey[] = [[DOCUMENTS_GET_MANY]];

      if (cargoId) keys.push([CARGO_GET_ONE, cargoId]);

      return keys;
    },
  });
};
